var _defs, _rect, _g, _rect2, _rect3, _tspan, _tspan2, _tspan3, _tspan4, _rect4, _rect5, _rect6, _tspan5, _tspan6, _tspan7, _path, _rect7, _tspan8, _tspan9, _tspan10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimelineDavidic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    width: 400,
    height: 80,
    viewBox: "0 0 105.83 21.167",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient959",
    x1: 1.8176,
    x2: 103.75,
    y1: 44.459,
    y2: 44.459,
    gradientTransform: "matrix(1.0382 0 0 1 -1.8692 -30.516)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop953",
    stopColor: "#cfc9c9",
    offset: 0.89444
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop955",
    stopColor: "#cfc9c9",
    stopOpacity: 0,
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "timeline",
    x: 0.017905,
    y: 13.229,
    width: 105.83,
    height: 1.426,
    fill: "url(#linearGradient959)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#b3b3b3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "tic5000bc",
    x: 6.8792,
    y: 13.237,
    width: 0.31411,
    height: 3.3283
  }), /*#__PURE__*/React.createElement("rect", {
    id: "tic4000bc",
    x: 20.108,
    y: 13.237,
    width: 0.31411,
    height: 3.9401
  }), /*#__PURE__*/React.createElement("rect", {
    id: "tic3000bc",
    x: 33.337,
    y: 13.237,
    width: 0.31411,
    height: 3.3283
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "tic0",
    x: 73.025,
    y: 13.237,
    width: 0.17871,
    height: 6.2164,
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "tic1000",
    x: 86.254,
    y: 13.237,
    width: 0.31411,
    height: 3.3283,
    fill: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#999999",
    fontFamily: "sans-serif",
    fontSize: "2.1167px",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("text", {
    id: "text4000bc",
    x: 14.456765,
    y: 19.461498,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1067",
    x: 14.456765,
    y: 19.461498,
    fill: "#999999",
    fontSize: "2.1167px",
    strokeWidth: 0.26458
  }, "4000 B.C.E."))), /*#__PURE__*/React.createElement("text", {
    id: "text2000bc",
    x: 40.173336,
    y: 18.948879,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1067-7",
    x: 40.173336,
    y: 18.948879,
    fill: "#999999",
    fontSize: "2.1167px",
    strokeWidth: 0.26458
  }))), /*#__PURE__*/React.createElement("text", {
    id: "text2000",
    x: 93.847717,
    y: 18.932314,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1067-7-7",
    x: 93.847717,
    y: 18.932314,
    fill: "#999999",
    fontSize: "2.1167px",
    strokeWidth: 0.26458
  }, "2000 C.E."))), /*#__PURE__*/React.createElement("text", {
    id: "text0",
    x: 66.735229,
    y: 18.932314,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1067-7-5",
    x: 66.735229,
    y: 18.932314,
    fill: "#999999",
    fontSize: "2.1167px",
    strokeWidth: 0.26458
  }, "B.C.E   C.E.")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "highlight",
    x: 59.346,
    y: 13.23,
    width: 0.76597,
    height: 1.4261,
    fill: "#de8787"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "tic4000bc-7",
    x: 46.55,
    y: 13.243,
    width: 0.31411,
    height: 3.9401,
    fill: "#b3b3b3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "tic4000bc-7-8",
    x: 99.492,
    y: 13.229,
    width: 0.31411,
    height: 3.9401,
    fill: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("text", {
    id: "text435",
    x: 48.801109,
    y: 10.378563,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "2.1167px",
    strokeWidth: 0.26458,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan433",
    x: 48.801109,
    y: 10.378563,
    fontSize: "2.1167px",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan487",
    fontWeight: "bold"
  }, "Davidic covenant"), " c. 1070 B.C.E"))), /*#__PURE__*/React.createElement("text", {
    id: "text497",
    x: 61.818123,
    y: 3.8860676,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "2.1167px",
    strokeWidth: 0.26458,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan495",
    x: 61.818123,
    y: 3.8860676,
    fontWeight: "bold"
  }, "Solomon's reign")), _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan499",
    x: 61.818123,
    y: 6.5319052
  }, "1037 - 998 B.C.E."))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path553",
    transform: "matrix(.50667 0 0 .50667 45.707 6.1437)",
    d: "m27.408 13.377-2.0253-3.5079 4.0506-1e-7z",
    fill: "#de8787",
    strokeLinejoin: "bevel",
    strokeWidth: 0.98452
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "tic1000bc",
    x: 59.783,
    y: 13.227,
    width: 0.31411,
    height: 3.3283,
    fill: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("text", {
    id: "text491",
    x: 58.076916,
    y: 3.8528278,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "2.1167px",
    strokeWidth: 0.26458,
    "text-align": "end",
    textAnchor: "end",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan489",
    x: 58.076916,
    y: 3.8528278,
    fontWeight: "bold",
    "text-align": "end"
  }, "David's reign")), _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan493",
    x: 58.076916,
    y: 6.4986653,
    "text-align": "end"
  }, "1077 - 1038 B.C.E."))), /*#__PURE__*/React.createElement("text", {
    id: "text653",
    x: 40.951157,
    y: 19.445875,
    fill: "#999999",
    fontFamily: "sans-serif",
    fontSize: "2.1167px",
    strokeWidth: 0.26458,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan651",
    x: 40.951157,
    y: 19.445875,
    fill: "#999999",
    fontSize: "2.1167px",
    strokeWidth: 0.26458
  }, "2000 B.C.E.")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineDavidic);
export default __webpack_public_path__ + "static/media/timeline-davidic.9de1a3c2a3906290855f028df8154d5a.svg";
export { ForwardRef as ReactComponent };